import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    standalone: false,
  selector: 'integration-apps-oscal-sap',
  templateUrl: './integration-apps-oscal-sap.component.html',
  styleUrls: ['./integration-apps-oscal-sap.component.css'],
})
export class IntegrationAppsOscalSapComponent implements OnInit {
  @Input() sapProfiles: any[];
  @Input() settings: any;
  @Input() settingsForm: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.settingsForm.addControl(
      'sapProfile',
      this.fb.control('', Validators.required)
    );
    this.settingsForm.addControl(
      'isRlink',
      this.fb.control('', Validators.required)
    );
    this.settingsForm.addControl(
      'dummyRlink',
      this.fb.control('', Validators.required)
    );

    this.settingsForm.patchValue(this.settings);
  }
}
